// Shared helpers for showing a supplier price in BOTH the entered currency and SEK.
// Prices are stored as { purchase_price/unit_price, currency } where currency is "SEK" or "EUR".
// When a price was entered in EUR we show SEK as the primary value (converted with the
// current exchange rate) and the original EUR amount small underneath / in parentheses.

const DEFAULT_RATE = 11.5;

export const convertToSEK = (price, currency, rate = DEFAULT_RATE) => {
  const p = Number(price) || 0;
  return (currency === "EUR") ? p * rate : p;
};

export const formatSEK = (value) => `${Math.round(Number(value) || 0).toLocaleString("sv-SE")} kr`;

export const formatOriginal = (price, currency) => {
  const p = Number(price) || 0;
  if (currency === "EUR") return `${Math.round(p).toLocaleString("sv-SE")} €`;
  return `${Math.round(p).toLocaleString("sv-SE")} kr`;
};

// Inline text form, e.g. for dropdown options / labels: "6 785 kr (590 €)"
export const dualPriceText = (price, currency, rate = DEFAULT_RATE) => {
  const sek = formatSEK(convertToSEK(price, currency, rate));
  if (currency === "EUR") return `${sek} (${formatOriginal(price, "EUR")})`;
  return sek;
};

// Stacked JSX: SEK primary, original EUR small underneath (only when currency is EUR).
export function DualPrice({ price, currency, rate = DEFAULT_RATE, className = "", subClassName = "", align = "right", testId }) {
  const sek = convertToSEK(price, currency, rate);
  return (
    <span className={`inline-flex flex-col leading-tight ${align === "right" ? "items-end" : "items-start"} ${className}`} data-testid={testId}>
      <span className="font-medium">{formatSEK(sek)}</span>
      {currency === "EUR" && (
        <span className={`text-xs text-muted-foreground ${subClassName}`}>{formatOriginal(price, "EUR")}</span>
      )}
    </span>
  );
}

export default DualPrice;
